import React, { useState, createContext, useContext } from 'react';
import FormPopup from './FormPopup';

// Create context for form management
const FormContext = createContext();

export const useForm = () => useContext(FormContext);

export const FormProvider = ({ children }) => {
  const [generalFormOpen, setGeneralFormOpen] = useState(false);
  const [summerFormOpen, setSummerFormOpen] = useState(false);
  
  const openGeneralForm = () => {
    setGeneralFormOpen(true);
    setSummerFormOpen(false);
  };
  
  const openSummerForm = () => {
    setSummerFormOpen(true);
    setGeneralFormOpen(false);
  };
  
  const closeAllForms = () => {
    setGeneralFormOpen(false);
    setSummerFormOpen(false);
  };
  
  return (
    <FormContext.Provider value={{ openGeneralForm, openSummerForm, closeAllForms }}>
      {children}
      <FormPopup isOpen={generalFormOpen} onClose={closeAllForms} formType="general" />
      <FormPopup isOpen={summerFormOpen} onClose={closeAllForms} formType="summer" />
    </FormContext.Provider>
  );
};

export default FormProvider;
